import { Component } from '@angular/core';
import { ToastController, NavParams } from 'ionic-angular';
import { CfgService } from '../../app/door/cfgService';
import { CfgEndpoint } from '../../app/door/cfgEndpoint';

@Component({
  selector: 'pidoor-cfg',
  templateUrl: 'cfg.html'
})
export class CfgPage {
  public get cfg() { return this.doorService.cfg; }
  public set cfg(value: CfgEndpoint[]) { this.doorService.cfg = value; this.doorService.cfgPersist(); }

  public ncfg: CfgEndpoint
  public isNew = false;
  public editIdx: number;
  public isSaving = false;
  public savingError: string;
  public isTesting = false;
  public testingError: string;

  // public cfg: any;

  constructor(private navParams: NavParams, private doorService: CfgService, public toastCtrl: ToastController) {
    const addNew = navParams.get("addNew");
    if (addNew === true) this.newCfg();
  }

  public remove(idx: number, cfg: CfgEndpoint) {
    this.cfg.splice(idx, 1);
    this.doorService.cfgPersist();
  }
  public open(idx: number, cfg: CfgEndpoint) {
    this.ncfg = JSON.parse(JSON.stringify(cfg));
    this.isNew = false;
    this.editIdx = idx;
  }
  public newCfg = () => {
    this.isNew = true;
    this.ncfg = new CfgEndpoint();
    this.ncfg.Url = window.location.href + "/0"
  }
  public save = (): Promise<void> => {
    return new Promise<void>((resolve, reject) => {
      this.isSaving = true;

      // todo test login
      this.doorService.cfgTest(this.ncfg).then(() => {
        if (this.isNew) {
          if (!this.cfg) this.cfg = [];
          this.cfg.push(this.ncfg);
        }
        else if (this.editIdx !== undefined) {
          this.cfg[this.editIdx] = this.ncfg;
        }

        this.doorService.cfgPersist();
        this.isNew = false;
        this.ncfg = undefined;
        this.toastCtrl.create({
          message: `Refresh OK`,
          duration: 1000,
          position:'bottom'
        }).present();

      }, (error) => {
        this.savingError = `Error saving: ${error}`;
        this.toastCtrl.create({
          message: this.savingError,
          duration: 5000,
          position:'bottom'
        }).present();
        this.isSaving = false;

      }).catch((ex) => {
        this.savingError = `Error saving: ${ex}`;
        this.toastCtrl.create({
          message: this.savingError,
          duration: 5000,
          position:'bottom'
        }).present();
        this.isSaving = false;
      });


    });
  }

  public refresh = (idx: number, cfg: CfgEndpoint): Promise<void> => {
    return new Promise<void>((resolve, reject) => {
      this.isTesting = true;
      this.doorService.cfgTest(cfg).then(() => {
        if (this.editIdx !== undefined) {
          this.cfg[this.editIdx] = this.ncfg;
        }
        this.doorService.cfgPersist();
        this.toastCtrl.create({
          message: `Refresh OK`,
          duration: 1000,
          position:'bottom'
        }).present();
        this.isTesting = false;
      }, (error) => {
        this.testingError = `Error: ${error}`;
        this.toastCtrl.create({
          message: this.testingError,
          duration: 5000,
          position:'bottom'
        }).present();
        this.isTesting = false;

      }).catch((ex) => {
        this.testingError = `Error: ${ex}`;
        this.toastCtrl.create({
          message: this.testingError,
          duration: 5000,
          position:'bottom'
        }).present();
        this.isTesting = false;
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/cfg/cfg.ts